import React from 'react';
import { bool, func, instanceOf, string } from 'prop-types';
import PortalModal from '../../components/common/Modal/PortalModal';
import addNewIcon from '../../images/contract-admin-icons/Frame.svg';

const modalStyles = {
  left: '30%',
  top: '10%',
  width: '380px',
  height: '674px,',
};

const CALocationMemriPopup = ({
  close,
  addNewRow,
  fieldChange,
  save,
  isModalOpen,
  showErrorMessage,
  showError,
  userArray,
}) => {
  return (
    <PortalModal
      title="MEMRI User ID Information"
      isShowing={isModalOpen}
      dialogStyles={modalStyles}
      onCloseClicked={close}
    >
      <div className="windowClass">
        <div className="subWindowClass">
          <div className="row loginDivClass">
            <span className="ca-add-user-form-heading loginIdClass">
              Login ID
            </span>
            <span className="ca-add-user-form-heading seatsDivClass">
              Seats
            </span>
          </div>
          {userArray &&
            userArray.length > 0 &&
            userArray.map((item, index) => {
              return (
                <div className="rowDivClass row ca-add-user third-bock">
                  <div className="popupMemriClassName">
                    <input
                      id="popUpUserId"
                      name="popUpUserId"
                      className="form-control"
                      title="User ID"
                      type="text"
                      contentEditable
                      value={item.memriUser}
                      onChange={e => fieldChange(e, 'userId', index)}
                    />
                  </div>
                  <div className="popupSeatsClassName">
                    <input
                      id="popUpseatsId"
                      name="popUpseatsId"
                      className="form-control"
                      title="Seats"
                      type="text"
                      value={item.seats}
                      onChange={e => fieldChange(e, 'seats', index)}
                      contentEditable
                    />
                  </div>
                </div>
              );
            })}
        </div>
        {showError && <span className="errorDivClass">{showErrorMessage}</span>}
        <div className="addRowMainDivClass">
          <div className="addRowDivClass">
            <span className="ca-add-user-form-heading">
              <button type="button" onClick={addNewRow}>
                <img
                  src={addNewIcon}
                  alt="Add New"
                  className="ca-add-another-btn"
                />
              </button>
              Add User
            </span>
          </div>
          <div className="buttonMainDivClass">
            <button
              type="button"
              onClick={close}
              className="normalLowRow cancelBtnClass"
            >
              Cancel
            </button>
            <button
              type="button"
              className="button saveBtnClass"
              onClick={e => save(e)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </PortalModal>
  );
};

CALocationMemriPopup.propTypes = {
  close: func,
  addNewRow: func,
  fieldChange: func,
  save: func,
  isModalOpen: bool,
  showErrorMessage: string,
  showError: bool,
  userArray: instanceOf(Array),
};

export default CALocationMemriPopup;
